import './App.css';
import Login from './pages/Login';
import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from './components/DashboardLayout';
import Profile from './pages/Profile';
import RequireAuth from "./RequireAuth";
import Rf from "./pages/Rf";
import Events from "./pages/Events";
import Vendors from "./pages/Vendors";
import Approval from "./pages/Approval";
import Bank from "./pages/Bank";
import Account from "./pages/Account";
import Register from "./pages/Register";
import FilteredRf from "./pages/FilteredRf";
import RfDetails from "./pages/RfDetails";
import Create from "./pages/Create";
import UpdateRf from "./pages/UpdateRf"; 
import Dashboard from './pages/Dashboard';
import NProgress from "nprogress";
import 'nprogress/nprogress.css';
import DashboardFilteredEvent from './pages/DashboardFilteredEvent';
import DashboardFilteredDateEvent from './pages/DashboardFilteredDateEvent';
import DashboardFilteredDate from './pages/DashboardFilteredDate';
import Karyawan from './pages/Karyawan';
import RfServerSide from './pages/RfServerSide';
import Ajuan from './pages/Ajuan';
import DetailTemperature from './pages/DetailTemperature';
import DetailTemperature2 from './pages/DetailTemperature2';
import DetailWaterFlow from './pages/DetailWaterFlow';
import DetailWaterFlow2 from './pages/DetailWaterFlow2';
import DetailWaterLevel from './pages/DetailWaterLevel';
import DetailWaterLevel2 from './pages/DetailWaterLevel2';
import DetailWaterLevel3 from './pages/DetailWaterLevel3';
import AjuanMobile from './pages/m/Ajuan';

NProgress.configure({ showSpinner: true });

function App() {
  
  return (
    <Routes>
        <Route path="/detail-waterflow" element={<DetailWaterFlow />} />
        <Route path="/detail-waterflow2" element={<DetailWaterFlow2 />} />
        <Route path="/detail-waterlevel" element={<DetailWaterLevel />} />
        <Route path="/detail-waterlevel2" element={<DetailWaterLevel2 />} />
        <Route path="/detail-waterlevel3" element={<DetailWaterLevel3 />} />
        <Route path="/detail-temperature" element={<DetailTemperature />} />
        <Route path="/detail-temperature2" element={<DetailTemperature2 />} />
        <Route path="/login" element={<Login />} />
        <Route path="register" element={<Register />} />
        {/* Layout dengan sidebar dan navbar */}
        <Route path="/" element={
          <RequireAuth>
           <DashboardLayout />
          </RequireAuth>}>
          <Route path="/" element={<Ajuan />} />
          <Route path="/m/ajuan" element={<AjuanMobile />} />
          <Route path="/RfServerSide" element={<RfServerSide />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="events" element={<Events />} />
          <Route path="/dashboardFilteredEvent/:id" element={<DashboardFilteredEvent key={window.location.pathname} />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="karyawan" element={<Karyawan />} />
          <Route path="dashboardFilteredDateEvent" element={<DashboardFilteredDateEvent />} />
          <Route path="dashboardFilteredDate" element={<DashboardFilteredDate />} />
          <Route path="approval" element={<Approval />} />
          <Route path="bank" element={<Bank />} />
          <Route path="account" element={<Account />} />
          <Route path="filteredRf" element={<FilteredRf />} />
          <Route path="detail/:id" element={<RfDetails />} />
          <Route path="create" element={<Create />} />
          <Route path="ajuan" element={<Ajuan />} />
          <Route path="updateRf/:id" element={<UpdateRf />} />
        </Route>
      </Routes>
  );
}

export default App;
